import { LoadingStatusManager } from '@@containers/LoadingStatusManager';
import { generateLookupKeyForRichTextEditorLoadingStatuses } from '@@containers/LoadingStatusManager/utils';
import snackbar, { type SnackbarKey } from '@@containers/Snackbar';
import i18n from '@@lib/i18n/i18n';

export const createHasLoadingElement = (editorId: string) => {
    const snackbarKeys = new Set<SnackbarKey>();

    return async () => {
        const key = generateLookupKeyForRichTextEditorLoadingStatuses({
            editorId,
        });

        const hasLoadingElement = await LoadingStatusManager.isLoading({ key });

        if (hasLoadingElement) {
            snackbarKeys.add(snackbar.error(i18n.t('editor.validation.uploading')));

            // t('editor.validation.uploading')
            return ['editor.validation.uploading'];
        }

        snackbarKeys.forEach((key) => snackbar.close(key));
        snackbarKeys.clear();
    };
};
